export enum AdminRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PARTNER_ADMIN = 'PARTNER_ADMIN',
}

export type AdminJwtUser = {
  id: number
  username: string
  name?: string
  role?: AdminRole
}
